import React from 'react';

import FileManagerView from '../view/FileManagerView';
import FileManagerHeader from '../header/FileManagerHeader';

function FileManagerContainer() {
  return (
    <div className="px-lg-2 r-px-0 pb-3">
      <FileManagerHeader />
      <FileManagerView />
    </div>
  );
}

export default FileManagerContainer;
